import {
  QuickBooksTradeResponse,
  CreateQuickBooksTradeRequest,
} from "./types";
import axiosInstance from "../axiosInstance";

export const getQuickBooksTrade = async (
  companyUuid: string,
): Promise<QuickBooksTradeResponse | null> => {
  const response = await axiosInstance.get<{
    data: QuickBooksTradeResponse | null;
  }>(`/api/private/companies/${companyUuid}/quickbooks/trade`);
  return response.data.data;
};

export const createQuickBooksTrade = async (
  companyUuid: string,
  request: CreateQuickBooksTradeRequest,
): Promise<QuickBooksTradeResponse> => {
  const response = await axiosInstance.post<{
    data: QuickBooksTradeResponse;
  }>(`/api/private/companies/${companyUuid}/quickbooks/trade`, request);
  return response.data.data;
};